<script>
    export default {
        props: {
            task: {
                required: true,
                type: Object,
            },
            isSigned: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                completed: this.task.completed_at !== null,
                error: '',
                ignoreEvent: false,
            };
        },
        computed: {
            unableToCompleteMessage() {
                if (this.task.can_be_completed) {
                    return null;
                }

                return `Du måste klarmarkera "${this.task.parent.body}" först!`;
            },
        },
        methods: {
            async completeTask(payload) {
                this.error = '';

                try {
                    await axios.post(route('api.completed-tasks.store', this.task), payload);

                    this.handleSuccessfulRequest('Klarmarkerade uppgiften!');

                    return true;
                } catch (e) {
                    flash_error('Kunde inte klarmarkera uppgiften, försök igen!');

                    return false;
                }
            },
            async unCompleteTask() {
                this.error = '';

                try {
                    await axios.delete(route('api.completed-tasks.destroy', this.task));

                    this.handleSuccessfulRequest('Tog bort klarmarkering på uppgiften!');

                    return true;
                } catch (e) {
                    flash_error('Kunde inte spara, försök igen!');

                    return false;
                }
            },
            handleSuccessfulRequest(successMessage) {
                this.$emit('finished');
                flash_success(successMessage);
            },
            async uploadMedia() {
                const formData = new FormData(this.$refs.form);
                const config = {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                };

                try {
                    await axios.post(
                        route('api.tasks.upload', this.task),
                        formData,
                        config,
                    );

                    flash_success('Fil uppladdad');
                } catch (e) {
                    flash_error('Kunde inte ladda upp filen, försök igen!');
                }

                this.$emit('finished');
            },
            async deleteMedia(media, entityName) {
                try {
                    await axios.delete(route('api.tasks.files.destroy', [this.task, media]));
                } catch (e) {
                    flash_error(`Kunde inte radera ${entityName}, försök igen!`);
                }

                this.$emit('finished');
            },
        },
    };
</script>
